<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NQzRzL/tc-custom/9781429967372.jpg?1730634343926" alt="This image is the cover for the book All the Rage, Repairman Jack"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All the Rage, Repairman Jack
      </h1>
      <p class="bookDescription body article font2">
        <b>Repairman Jack must stop a new drug that unleashes otherworldly rage in this supernatural thriller by the <i>New York Times</i>–bestselling author of <i>The Tomb</i>.</b><br/><br/>Can you imagine a new chemical compound that heightens your assertiveness, opening the door to your primal self and giving you a physical and mental edge wherever you compete? The non-addictive designer drug Berserk promises just that. It gives you a God-like feeling of supremacy . . . and releases uncontrollable rage that could turn you into a killer . . .<br/><br/>Jack finds himself fighting the criminal forces behind Berserk. After combing New York City’s criminal underworld, Jack realizes that the drug comes from a most surprising source . . . a source that may have deadly effects on Jack’s life and the lives of those he cares most about . . .<br/><br/><b>“One of the all-time great characters in one of the all-time great series.” —Lee Child</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        F. Paul Wilson
      </h2>
      
      <p class="authorDescription body article">F. Paul Wilson is the author of more than fifty books spanning various genres, including science fiction, horror, thriller, and more. Four of his novels have been <I>New York Times</I> bestsellers, and his work has earned him four Prometheus Awards, the prestigious Inkpot Award from the San Diego Comic-Con, and the Pioneer Award from the RT Booklovers Convention.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?92592a46